function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    map\n  ");

var _ref2 = /*#__PURE__*/React.createElement("polyline", {
  points: "26.16 13.94 38.47 16.96 38.47 35.63 26.16 32.61 26.16 13.94 13.84 16.96",
  fill: "none",
  stroke: "#af57a2",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  points: "13.84 35.63 1.53 32.61 1.53 13.94 13.84 16.96 13.84 35.63 26.16 32.61",
  fill: "none",
  stroke: "#af57a2",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.56,11.38c0,7.62-7,11.69-7,11.69s-7-4.07-7-11.69a7,7,0,1,1,14,0Z",
  fill: "#fff",
  stroke: "#045ca0",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.55,
  cy: 11.38,
  r: 2.61,
  fill: "none",
  stroke: "#045ca0",
  strokeLinejoin: "round"
});

function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgMap;